import React, { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { faxSocket } from '@services/websocket/socket'
import { fetchAllFax, fetchFaxCounts } from '@store/actions/fax.action'
import { getFaxFetchView } from '@utils/fax.util'

interface IncomingFaxEvent {
  externalId: string | null
  fromNumber: string
  toNumber: string
  pageCount: number | null
  dbName: string | null
  clinicId: string | null
}

interface FaxStatusUpdateEvent {
  externalId: string | null
  status: string | null
  intent: string | null
  failureReason: string | null
  dbName: string | null
  clinicId: string | null
}

const FaxSocketListener: React.FC = () => {
  const dispatch = useAppDispatch()
  const selectedClinic = useAppSelector((state) => state.clinic.selectedClinic)
  const activeMessageTab = useAppSelector(
    (state) => state.messageCenter.activeTab,
  )
  const activeFolder = useAppSelector((state) => state.fax.activeFolder)

  useEffect(() => {
    const refreshForClinic = (eventClinicId: string | null): void => {
      if (!selectedClinic) return
      if (eventClinicId && eventClinicId !== selectedClinic.clinic_id) return

      if (activeMessageTab === 'fax') {
        dispatch(fetchAllFax(getFaxFetchView(activeFolder)))
      } else {
        dispatch(fetchFaxCounts())
      }
    }

    const handleIncomingFax = (event: IncomingFaxEvent): void => {
      refreshForClinic(event.clinicId)
    }

    const handleFaxStatusUpdate = (event: FaxStatusUpdateEvent): void => {
      refreshForClinic(event.clinicId)
    }

    faxSocket.on('incoming-fax', handleIncomingFax)
    faxSocket.on('fax-status-update', handleFaxStatusUpdate)
    return () => {
      faxSocket.off('incoming-fax', handleIncomingFax)
      faxSocket.off('fax-status-update', handleFaxStatusUpdate)
    }
  }, [dispatch, selectedClinic, activeMessageTab, activeFolder])

  return null
}

export default FaxSocketListener
